import * as React from "react";

// HOC
import withAccountHOC from "./withAccountHOC"


// components
import Modal from "~/components/modal/Modal";

// actions
import {
    loginWithFacebook,
    loginWithGoogle,
    registerLocal
} from "~/actions/account";

interface IModalRegister {
    initRef: Function;
    dispatch: Function;
    isLoading: boolean;
    goWithAction: Function;
    error: string;
}

class ModalRegister extends React.Component<IModalRegister, any>{
    constructor(props: IModalRegister) {
        super(props);
        this.state = {
            error: "",
        }
    }

    componentWillReceiveProps(nextProps: IModalRegister) {
        this.setState({error: nextProps.error})
    }

    refTmp = {value: ""}

    emailRef = {...this.refTmp};
    passwordRef = {...this.refTmp};
    cfpasswordRef = {...this.refTmp};
    fullnameRef = {...this.refTmp};

    baseValidate = (data: any) => new Promise((resolve, reject) => {
        let validate = Object.entries({
            email: data.email !== "",
            password: data.password !== "",
            cfpassword: data.cfpassword !== "" && data.cfpassword === data.password,
            fullname: data.fullname !== ""
        }).find(([key, value]) => value === false)

        !validate ? resolve(data) : reject(`${validate[0]} is incorrect!`)
    })

    onClickLoginSocial = (type: string) => (): any => {
        switch (type) {
            case "facebook": return this.props.goWithAction(loginWithFacebook())
            case "google": return this.props.goWithAction(loginWithGoogle())
        }
    }

    onSubmit = async (e: any) => {
        e.preventDefault();
        this.baseValidate({
            email: this.emailRef.value,
            password: this.passwordRef.value,
            cfpassword: this.cfpasswordRef.value,
            fullname: this.fullnameRef.value,
        })
        .then((account: any) => {
            delete account.cfpassword;
            this.props.goWithAction(registerLocal(account));
        })
        .catch(error => {
            this.setState({ error })
        })
    }

    render() {
        return (
            <div className="ModalLogin">
                <Modal
                    bsSize="sm"
                    title="Register"
                    initRef={this.props.initRef}
                >
                    <div className="ModalLogin__show">
                        <div className="ModalLogin__show__content">
                            <div className="ModalLogin__show__content__header">
                                <div className="social">
                                    <div className="btn photo" onClick={this.onClickLoginSocial('facebook')}>
                                        <img src={`/assets/images/social/fb.png`} alt="" />
                                    </div>
                                    <div className="btn photo" onClick={this.onClickLoginSocial('google')}>
                                        <img src={`/assets/images/social/gg.png`} alt="" />
                                    </div>
                                    <div className="btn photo">
                                        <img src={`/assets/images/social/github.png`} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="ModalLogin__show__content__body">
                                <form onSubmit={this.onSubmit}>
                                    <div className="line"></div>
                                    <div className="form">
                                        <div>
                                            <input type="text" placeholder='Email' ref={(ref: any) => this.emailRef = ref} />
                                        </div>
                                        <div>
                                            <input type="password" placeholder='Password' ref={(ref: any) => this.passwordRef = ref} />
                                        </div>
                                        <div>
                                            <input type="password" placeholder='Confirm' ref={(ref: any) => this.cfpasswordRef = ref} />
                                        </div>
                                        <div>
                                            <input type="text" placeholder='Fullname' ref={(ref: any) => this.fullnameRef = ref} />
                                        </div>
                                        <div>
                                            <button type="submit">REGISTER</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />
                            <p className="text-danger">{this.state.error || this.props.error}</p>
                            {
                                this.props.isLoading &&
                                <div className="text-center">
                                    <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                                </div>
                            }
                            <br />
                            <br />
                            <div className="ModalLogin__show__content__footer">
                                <p>If you have an account? <a href="">click here</a></p>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withAccountHOC(ModalRegister)



// WEBPACK FOOTER //
// ./src/components/account/ModalRegister.tsx